import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';

const DEFAULT_ERR_MESSAGES: { [key: string]: string } = {
  '400': 'The server cannot process the request',
  '401': 'You are unauthorized',
  '403': 'You do not have access to this page',
  '404': 'Requested resource is not found',
  '413': 'Your data is too large',
  '429': 'You are sending too many requests. You are rate limited',
  '500': 'Internal server error acquired',
};
@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private handledErrors: any[] = [];
  constructor(private messageService: NzMessageService) {}


  handleError(error: any) {
    if (this.handledErrors.indexOf(error) !== -1) {
      return;
    }
    console.error(error);

    this.handledErrors.push(error);

    if (error instanceof Error) {
      this.notifyAboutError(error.message);
      return;
    }

    if (typeof error === 'string') {
      this.notifyAboutError(error);
      return;
    }

    if (error instanceof HttpErrorResponse) {
      const payload = error.error;

      if (payload) {
        // Case 1: backend returns plain text string
        if (typeof payload === 'string') {
          this.notifyAboutError(payload);
          return;
        }

        // Case 2: standard { message: string }
        if (payload.message) {
          this.notifyAboutError(payload.message);
          return;
        }

        // Case 3: custom { status: string } with human-readable text (e.g. "Email already used")
        if (payload.status && typeof payload.status === 'string' && isNaN(Number(payload.status))) {
          this.notifyAboutError(payload.status);
          return;
        }

        // Case 4: Symfony validation style { errors: [...] }
        if (Array.isArray(payload.errors) && payload.errors.length) {
          const firstError = payload.errors[0];
          const errorMsg = typeof firstError === 'string' ? firstError : JSON.stringify(firstError);
          this.notifyAboutError(errorMsg);
          return;
        }
      }

      // Fallback to generic mapping by HTTP status code
      this.notifyAboutDefaultError(error.status);
      return;
    }

    this.notifyAboutError('Error acquired, please try again later');
    return;
  }

  private notifyAboutError(errorMessage: string) {
    if (errorMessage.toLowerCase().indexOf('jwt token') !== -1) {
      return;
    }

    this.messageService.create('error', errorMessage);
  }

  private notifyAboutDefaultError(status: number) {
    const defaultMessage: string | undefined = DEFAULT_ERR_MESSAGES[status.toString()];

    if (defaultMessage) {
      this.notifyAboutError(defaultMessage);
      return;
    }

    this.notifyAboutError('Error acquired, please try again later');
  }
}
